import axios from "../../../configs/axios";

export type LanguageApp = "admin" | "partner";
export const LANGUAGE_APPS: LanguageApp[] = ["admin", "partner"];

/** code -> display name, e.g. { it: "Italiano", en: "English" } */
export type Languages = Record<string, string>;
export type Catalog = Record<string, any>;

export const languagesAPI = {
  getLanguages: async (): Promise<Languages> => {
    const response = await axios.get("/admin/languages");
    return response.data.data;
  },

  addLanguage: async (data: { code: string; name: string }) => {
    const response = await axios.post("/admin/languages", data);
    return response.data.data;
  },

  deleteLanguage: async (code: string) => {
    const response = await axios.delete(`/admin/languages/${code}`);
    return response.data.data;
  },

  getCatalog: async (app: LanguageApp, code: string): Promise<Catalog> => {
    const response = await axios.get(`/admin/languages/${app}/${code}`);
    return response.data.data;
  },

  saveCatalog: async (app: LanguageApp, code: string, catalog: Catalog) => {
    const response = await axios.put(`/admin/languages/${app}/${code}`, catalog);
    return response.data.data;
  },
};
